<template>
  <div>
    <v-toolbar>
      <v-btn icon to="/notifications">
        <v-icon>arrow_back</v-icon>
      </v-btn>

      <v-toolbar-title>
        Disparo #{{ firing_id }}

        <span v-if="firing.id"> - {{ firing.approach_type }} - {{ firing.creditor_name }} </span>
      </v-toolbar-title>
    </v-toolbar>

    <v-container>
      <div v-if="loadingFiring" class="text-xs-center">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>

      <v-alert v-if="loadingFiringError" :value="true" type="error" class="text-xs-center" outline>
        <div>Não foi possível buscar o disparo.</div>

        <v-btn @click="getFiring" flat> Tentar novamente </v-btn>
      </v-alert>

      <div v-if="firing.id">
        <v-card class="blue white--text">
          <v-card-title>
            <span class="title">{{ firing.name }}</span>
          </v-card-title>

          <v-card-text>
            <div
              v-if="firing.strategy_snapshot && firing.strategy_snapshot.approach_id"
              class="headline mb-4">
              <div>
                Estratégia:

                <router-link
                  :to="{
                    path: '/strategies/production',
                    query: { creditor_id: firing.creditor_id, strategy_id: firing.strategy_id },
                  }"
                  class="white--text">
                  {{ firing.strategy_snapshot.name }}
                </router-link>
              </div>

              <div>
                Abordagem:

                <router-link
                  :to="'/approaches/' + firing.strategy_snapshot.approach_id"
                  class="white--text">
                  {{ firing.strategy_snapshot.approach.name }}
                </router-link>
              </div>
            </div>

            <div>
              Enviado {{ firing.created_at | formatDateAgo }} -
              {{ firing.created_at | formatDateTime }}
            </div>
          </v-card-text>

          <v-card-actions>
            <v-btn
              flat
              color="white"
              :href="'https://metabase.quiteja.com.br/question/11585?firing_id=' + firing.id"
              target="_blank">
              Webhooks <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-container grid-list-xl class="px-0">
          <v-layout row wrap>
            <v-flex md6>
              <v-card class="">
                <v-card-title class="red white--text">
                  <span class="title">Notificações</span>
                </v-card-title>
                <v-card-text>
                  <chart :options="chartNotification"></chart>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex md6>
              <v-card>
                <v-card-title class="green white--text">
                  <span class="title">Interações</span>
                </v-card-title>
                <v-card-text>
                  <chart :options="chartInteraction"></chart>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </v-container>
  </div>
</template>

<script>
import FiringService from "@/services/notification-history";

export default {
  props: ["firing_id"],

  data() {
    return {
      chartInteraction: null,
      chartNotification: null,
      firing: {},
      loadingFiring: false,
      loadingFiringError: false,
    };
  },

  created() {
    this.getFiring();
  },

  methods: {
    async getFiring() {
      if (this.loadingFiring) {
        return;
      }

      this.loadingFiring = true;
      this.loadingFiringError = false;

      try {
        this.firing = await FiringService.get(this.firing_id);
        document.title = `Disparo #${this.firing_id} - ${this.firing.name}`;

        this.createChartInteraction();
        this.createChartNotification();
      } catch (error) {
        console.error("Não foi possível buscar o disparo.", error);
        this.loadingFiringError = true;
      } finally {
        this.loadingFiring = false;
      }
    },

    createChartNotification() {
      let data = [];

      if (this.firing.simulated) {
        data.push({
          name: "Simuladas: " + new Number(this.firing.simulated).toLocaleString(),
          value: this.firing.simulated,
        });
      }

      if (this.firing.queued) {
        data.push({
          name: "Enfileiradas: " + new Number(this.firing.queued).toLocaleString(),
          value: this.firing.queued,
        });
      }

      if (this.firing.notifications) {
        data.push({
          name: "Enviadas: " + new Number(this.firing.notifications).toLocaleString(),
          value: this.firing.notifications,
        });
      }

      this.chartNotification = {
        series: [
          {
            name: "Funnel",
            type: "funnel",
            bottom: 10,
            left: 10,
            right: 10,
            top: 10,
            sort: "none",
            width: "80%",
            label: {
              show: true,
              position: "inside",
            },
            data: data,
          },
        ],
      };
    },

    createChartInteraction() {
      let data = [
        {
          name: "Acessos: " + new Number(this.firing.accessed).toLocaleString(),
          value: this.firing.accessed,
        },
        {
          name: "Logins: " + new Number(this.firing.localized).toLocaleString(),
          value: this.firing.localized,
        },
        {
          name:
            "Propostas confirmadas: " +
            new Number(this.firing.proposals_confirmed).toLocaleString(),
          value: this.firing.proposals_confirmed,
        },
        {
          name:
            "Propostas implantadas: " + new Number(this.firing.proposals_agreed).toLocaleString(),
          value: this.firing.proposals_agreed,
        },
      ];

      this.chartInteraction = {
        series: [
          {
            name: "Funnel",
            type: "funnel",
            bottom: 10,
            left: 10,
            right: 10,
            top: 10,
            sort: "none",
            width: "80%",
            label: {
              show: true,
              position: "inside",
            },
            data: data,
          },
        ],
      };
    },
  },
};
</script>

<style></style>
